import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Page from '../../components/page';
import PageMetadata from '../../components/page-metadata';
import { PageDescriptionDesktop } from '../../components/page-description';
import MasonryWrapper from '../../components/masonry-wrapper';
import CategoryList from '../../components/category-list';
import CategoryListMasonry from '../../components/category-list-masonry';
import AppLoaded from '../../components/app-loaded';
// import CreateCategoryCard from '../../components/create-category-card';
import { getCategories } from '../../selectors/categories-selectors';
import { getForumData } from '../../selectors/forum-data-selectors';
import { getIsHeaderEnabled } from '../../selectors/app-settings-selectors';
// import forAdminOnly from '../../hoc/for-admin-only';
// import forMobileOnly from '../../hoc/for-mobile-only';
import withDeviceType from '../../hoc/with-device-type';
import { pageOpened } from '../../actions/page-opened';
import { CATEGORIES_PAGE } from '../../services/detect-route';
import { replace } from '../../services/router-utils';
import { bindActionCreators } from 'redux';

// const CreateNewCategory = forMobileOnly(forAdminOnly(() => <CreateCategoryCard to="/create-category"/>));
const List = withDeviceType(({ isMobile, categories }) => {
  const Component = isMobile ? CategoryList : CategoryListMasonry;
  return (
    <MasonryWrapper isEnabled={!isMobile}>
      <Component categories={categories}/>
    </MasonryWrapper>
  );
});

export class CategoriesPage extends Component {
  componentDidMount() {
    const { categories, redirectToCategory } = this.props;
    if (categories.length === 1) {
      redirectToCategory(categories[0].slug);
    } else {
      this.props.pageOpened({ page: CATEGORIES_PAGE });
    }
  }
  render() {
    const { forumData, categories, isHeaderEnabled } = this.props;
    return (
      <Page>
        <PageMetadata description={forumData.description} image={forumData.cover}/>
        <PageDescriptionDesktop
          title={forumData.label}
          description={forumData.description}
          cover={forumData.cover}
          coverType={forumData.coverType}
          overlayColor={forumData.overlayColor}
          backgroundColor={forumData.backgroundColor}
          textColor={forumData.textColor}
          isCoverVisible={isHeaderEnabled}
        />
        <List categories={categories}/>
        <AppLoaded parent={this} selector="[data-hook=category-list-item]"/>
        {/*<CreateNewCategory/>*/}
      </Page>
    );
  }
}

CategoriesPage.propTypes = {
  forumData: PropTypes.object.isRequired,
  categories: PropTypes.array,
  redirectToCategory: PropTypes.func,
  pageOpened: PropTypes.func,
  isHeaderEnabled: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  categories: getCategories(state),
  forumData: getForumData(state),
  isHeaderEnabled: getIsHeaderEnabled(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      pageOpened,
      redirectToCategory: categorySlug => replace(`/${categorySlug}`),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesPage);



// WEBPACK FOOTER //
// ./app/containers/categories-page/categories-page.js